// Shared bits of the attendance pages (HR → Attendance, Attendance Admin).
export const fmtMins = (m) => (m == null ? "—" : `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`);

export const STATUS_CLS = {
  present: "bg-green-50 text-green-700 border-green-200",
  working: "bg-blue-50 text-blue-700 border-blue-200",
  absent_no_clockout: "bg-red-50 text-red-700 border-red-200",
  absent: "bg-red-50 text-red-700 border-red-200",
  not_in: "bg-slate-100 text-slate-600 border-slate-200",
};
